var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { themeLss } from "../../lss";
import styled from "../../styled";
import { Tab } from './Tab';
import { tabsNav } from './tabsNavigation';
var TabsContainer = styled.div(themeLss());
export var Tabs = function (_a) {
    var tabs = _a.tabs, selectedId = _a.selectedId, onSelect = _a.onSelect, lss = _a.lss, accessibilityLabel = _a.accessibilityLabel, id = _a.id;
    var ref = React.createRef();
    React.useEffect(function () {
        ref.current && tabsNav(ref.current);
    }, [ref]);
    return (React.createElement(TabsContainer, { id: id + "-tabs", ref: ref, role: "tablist", "aria-label": accessibilityLabel, lss: __assign({ display: 'flex', p: 'unset', borderBottom: 'regular' }, lss) }, tabs &&
        tabs.map(function (tab, index) { return (React.createElement(Tab, __assign({ idDescriptor: id, key: "tab-" + index, isSelected: selectedId === tab.id, onSelect: onSelect }, tab), tab.title)); })));
};
//# sourceMappingURL=Tabs.js.map